// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2PPdt","description":"PatientConsentPreview_description__V79pH"};